/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, {useEffect, useState} from 'react';
import {NavLink, useNavigate, useLocation, Location} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {IMenuItem} from '@app/modules/main/menu-sidebar/MenuSidebar';
import styled from 'styled-components';

const color = [
  'far fa-circle nav-icon text-primary',
  'far fa-circle nav-icon text-success',
  'far fa-circle nav-icon text-warning',
  'far fa-circle nav-icon text-danger',
  'far fa-circle nav-icon text-info',
  'far fa-circle nav-icon'
];

const MenuItem = ({
  menuItem,
  group,
  level = 0
}: {
  menuItem: IMenuItem;
  group: Number;
  level: number;
}) => {
  const [t] = useTranslation();
  const [isMenuExtended, setIsMenuExtended] = useState(false);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isMainActive, setIsMainActive] = useState(false);
  const [isOneOfChildrenActive, setIsOneOfChildrenActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuExtended(!isMenuExtended);
  };

  const handleMainMenuAction = () => {
    if (isExpandable) {
      toggleMenu();
      return;
    }
    navigate(menuItem.path ? menuItem.path : '/');
  };

  const calculateIsActive = (url: Location) => {
    setIsMainActive(false);
    setIsOneOfChildrenActive(false);
    let temp = false;
    if (isExpandable && menuItem && menuItem.children) {
      menuItem.children.forEach((item) => {
        if (item.path === url.pathname) {
          setIsOneOfChildrenActive(true);
          setIsMenuExtended(true);
          temp = true;
        }
      });
    } else if (menuItem.path === url.pathname) {
      setIsMainActive(true);
      temp = true;
    }

    console.log("temp1", menuItem.path);
    console.log("temp2", menuItem.name);
    console.log("temp3", temp);
  };

  useEffect(() => {
    console.log("location: ",location);
    if (location) {
      calculateIsActive(location);
    }
  }, [location, isExpandable, menuItem]);

  useEffect(() => {
    if (!isMainActive && !isOneOfChildrenActive) {
      setIsMenuExtended(false);
    }
  }, [isMainActive, isOneOfChildrenActive]);

  useEffect(() => {
    setIsExpandable(
      Boolean(menuItem && menuItem.children && menuItem.children.length > 0)
    );
  }, [menuItem]);

  return (
    <li className={`nav-item${isMenuExtended ? ' menu-open' : ''}`}>
      <a
        className={`nav-link${
          isMainActive || isOneOfChildrenActive ? ' active' : ''
        }`}
        role="link"
        onClick={handleMainMenuAction}
        style={{cursor: 'pointer'}}
      >
        {/* <i className="nav-icon fas fa-tachometer-alt" /> */}
        <i
          className={`nav-icon fas ${
            menuItem.icon ? menuItem.icon : 'fa-circle nav-icon'
          }`}
        />
        <p>{t<string>(menuItem.name)}</p>
        {isExpandable ? <i className="right fas fa-angle-left" /> : null}
      </a>

      {/* {
        isExpandable && menuItem && menuItem.children && (
          <ul
            className="nav nav-treeview"
            style={{display: isMenuExtended ? 'block' : 'none'}}
          >
            {menuItem.children.map((item, index) => (
              <MenuItem
                key={menuItem.name + menuItem.path + index}
                menuItem={item}
                group={group}
                level={level + 1}
              ></MenuItem>
            ))}
          </ul>
        )
      } */}

      {isExpandable &&
        menuItem &&
        menuItem.children &&
        menuItem.children.map((item, index) => (
          <ul key={item.name} className="nav nav-treeview">
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to={`${item.path}`}
                style={{
                  pointerEvents: item.enable === true ? 'visible' : 'none'
                }}
              >
                &nbsp;&nbsp;
                <i className={`${color[group.valueOf()]}`} />
                <p>{t<string>(item.name)}</p>
              </NavLink>
            </li>
          </ul>
        ))}
    </li>
  );
};

export default MenuItem;
